import React, { useState, useEffect } from "react";
import Table from "../../../../Components/UiComponents/Table/Table";
import { useNavigate } from "react-router-dom";
import {
  EditConvgIcon,
  DeleteConvgIcon,
} from "../../../../Components/IconComponents";
import { useDispatch } from "react-redux";
import { viewtaskcolumnsForExportView } from "../../../../JsonData/CreateTaskConfig";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import {
  getExportedColumnsData,
} from "../../../../Components/UiComponents/utils";
import { getTaskListURL, deleteTaskURL, getActiveMasterSOPList, getThemeURL } from "../../../../Services/EndPoints";
import { getData, putDataWithBody } from "../../../../Services/Services";
import Moment from "react-moment";
import { toast } from "react-toastify";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import Loader from "react-spinner-loader";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { Paperclip } from 'lucide-react';


const ViewTask = () => {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [rowCount, setRowCount] = useState(0);
  const [searchData, setSearchData] = useState([]);
  const [checkData, setCheckData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [imageSrc, setImageSrc] = useState("");
  
  // User permissions state
  const [userPermissions, setUserPermissions] = useState({
    canView: false,
    canEdit: false,
    canDelete: false,
  });

  // Parse web permissions from user profile
  const parseUserPermissions = (webPermissions) => {
    if (!webPermissions) {
      return { canView: false, canEdit: false, canDelete: false };
    }
    const permissions = webPermissions.split(',').map(p => p.trim().toUpperCase());
    
    return {
      canView: permissions.includes('V'),
      canEdit: permissions.includes('E'),
      canDelete: permissions.includes('D'),
    };
  };

  // Fetch user profile to determine permissions
  const getUserProfile = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      if (userProfile && userProfile.length > 0) {
        // Parse and set user permissions
        const permissions = parseUserPermissions(userProfile[0].web_permissions);
        setUserPermissions(permissions);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const handleImageClick = (src) => {
    setImageSrc(src);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setImageSrc("");
  };

  useEffect(() => {
    getUserProfile(); // Fetch user permissions on component mount
    getTaskLists();
    getSOPMasterList();
  }, []);

  useEffect(() => {
    sendDataToCentralStore(searchData);
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);

  const getShortenedText = (strLength, fulltext) => {
    let abbreviatedText = "";
    if (fulltext.length > strLength) {
      abbreviatedText = fulltext.substring(0, 25) + "...";
    } else {
      abbreviatedText = fulltext;
    }
    return <span title={fulltext}>{abbreviatedText}</span>;
  };

  async function getTaskLists() {
    setLoader(true);
    var taskList = await getData(getTaskListURL);
    let sortedList = taskList.sort((a, b) => {
      return new Date(b.created_on) - new Date(a.created_on);
    });
    setLoader(false);
    setData(sortedList);
    setRowCount(sortedList.length);
  }

  const getSOPMasterList = async () => {
    setLoader(true);
    var sopMasterList = await getData(getActiveMasterSOPList);
    let sortedList = sopMasterList.sort((a, b) => {
      return new Date(b.created_on) - new Date(a.created_on);
    });
    setLoader(false);
    setCheckData(sortedList);
  };
 
  // Function to check if a task name exists in checkData's task_list property
  const isTaskInMasterSOP = (taskName) => {
    if (!taskName || !checkData || checkData.length === 0) return false;
   
    // Check if the task name exists in any of the checkData task_list strings
    return checkData.some(item => {
      if (!item.task_list) return false;
      // Split the task_list string by commas and check if taskName is included
      const taskList = item.task_list.split(',').map(task => task.trim());
      return taskList.includes(taskName);
    });
  };

  function addNewHandler() {
    navigate("/sop-management/create-task");
  }

  const sendDataToCentralStore = (data) => {
    if (data.length > 0) {
      const columns = viewtaskcolumnsForExportView;
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, data),
        })
      );
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: t("taskmanagementtableheaders.sopname"),
        accessor: "task_name",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return getShortenedText(15, props.value);
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("taskmanagementtableheaders.incidenttype"),
        accessor: "incident_type",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return getShortenedText(15, props.value);
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("taskmanagementtableheaders.tasktype"),
        accessor: "task_type",
        disableSortBy: true,
      },
      {
        Header: t("taskmanagementtableheaders.assignedto"),
        accessor: "role_name",
        Cell: (props) => {
          if (props.value) {
            return getShortenedText(25, props.value);
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("taskmanagementtableheaders.Createdon"),
        accessor: "created_on",
        Cell: (props) => {
          if (props.value) {
            return <Moment format="DD-MM-YYYY, hh:mm A">{props.value}</Moment>;
          } else {
            return "NA";
          }
        },
        disableSortBy: false,
      },
      {
        Header: t("soprelatedtasktableheaders.Viewimage"),
        accessor: "task_file_name",
        disableSortBy: true,
        Cell: ({ value }) =>
          value ? (
            <Paperclip onClick={() => handleImageClick(value)} style={{ cursor: 'pointer', color: '#1a7a73',marginLeft:'15px' }}
              size={18}
              strokeWidth={1.5} />
          ) : (
            "NA"
          )
        ,
      },
      // Only show actions column if user has at least one permission
      ...(userPermissions.canEdit || userPermissions.canDelete 
        ? [{
            Header: t("taskmanagementtableheaders.action"),
            disableSortBy: true,
            Cell: (props) => {
              const [isdelete, setIsdelete] = useState(false);
              const deletePopUp = () => {
                setIsdelete(!isdelete);
              };
              const deleteTableDataById = async (id) => {
                let data = { id: id };
                var res = await putDataWithBody(deleteTaskURL, data, {});
                if (res.status === "success") {
                  getTaskLists();
                }
                toast.success(res.msg, {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000, // Close after 2 seconds
                });
                setIsdelete(false);
              };
 
              // Check if the task name is in any of the checkData task_list
              const taskName = props.row.original.task_name;
              const isDisabled = isTaskInMasterSOP(taskName);
 
              return (
                <div className="usertable__actionsicon">
                  {/* Edit Button - only show if user has edit permission */}
                  {userPermissions.canEdit && (
                    <span
                      onClick={() => {
                        if (!isDisabled) {
                          navigate("/sop-management/create-task", {
                            state: {
                              data: props.row.original,
                              edit: true
                            },
                          });
                        }
                      }}
                    >
                      <EditConvgIcon
                        value={props.value}
                        className={`me-2 ${isDisabled ? 'text-muted' : 'cursor-pointer'}`}
                        style={isDisabled ? { opacity: 0.5, } : {}}
                      />
                    </span>
                  )}

                  {/* Delete Button - only show if user has delete permission */}
                  {userPermissions.canDelete && (
                    <span onClick={!isDisabled ? deletePopUp : null}>
                      <DeleteConvgIcon
                        value={props.value}
                        className={`mr-1 ${isDisabled ? 'text-muted' : 'cursor-pointer'}`}
                        style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                      />
                    </span>
                  )}

                  {/* Delete Confirmation Popup */}
                  {isdelete && !isDisabled && (
                    <Confirmpopup
                      className="DeltePopup"
                      show={isdelete}
                      title={t("deletepopuptext")}
                      message={t("deletepopupmessage")}
                      handleToggle={deletePopUp}
                      row={props.row}
                      name={props.row.original.title}
                      deleteRow={deleteTableDataById}
                      cancel={t("cancelbutton")}
                      action={t("actionbutton")}
                    />
                  )}
                </div>
              );
            },
          }]
        : []),
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, checkData, userPermissions] // Add userPermissions as dependency
  );

  return (
    <div>
      <div className="create-user">
        <Loader
          show={loader}
          type="body"
          stack="vertical"
          message="Loading Data"
        />
        <div className="datatable__container">
          <Table
            data={data}
            title=""
            addButtonLabel={t("taskaddButtonLabel")}
            addNewHandler={addNewHandler}
            showFilter={false}
            setSearchData={setSearchData}
            columns={columns}
            numberOfRows={10}
            showExport={false}
            showReset={false}
            onExpand={false}
            showSearch={true}
            isHeaderFixed={true}
            rowCount={rowCount} // Pass rowCount to the Table component
            headerTableHeadStyle={{ background: "#1a7a73", color: "#FFFFFF" }}
            tableStyle={{
              border: "1px solid #f0f0f0",
              padding: "2px",
              borderRadius: "12px",
            }}
          />
        </div>
      </div>
      <Modal show={showModal} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: 'center' }}>
          <img
            src={imageSrc}
            alt="Preview"
            style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewTask;
